import React, { useState, useEffect } from 'react';
import { FaCircle } from 'react-icons/fa';
import { useSwipeable } from 'react-swipeable';
import image1 from '../assets/img/boyo.png'; 
import image2 from '../assets/img/guy2.jpg';
import image3 from '../assets/img/guy3.jpg';
import image4 from '../assets/img/guy5.jpg';
import image5 from '../assets/img/guy6.jpg';

const testimonies = [
  {
    id: 1,
    image: image1,
    quote: `❝I'm truly grateful for the scholarship I received. It has opened doors for me that I never thought possible.❞`,
    name: 'John Ekene',
    title: 'Scholarship Beneficiary',
  },
  {
    id: 2,
    image: image2,
    quote: `❝The scholarship not only helped me financially but also motivated me to excel in my studies and pursue my dreams.❞`,
    name: 'Mustapha Ahmed',
    title: 'Scholarship Beneficiary',
  },
  {
    id: 3,
    image: image3,
    quote: `❝Receiving the scholarship was a turning point in my life. It provided me with the opportunity to pursue higher education and achieve my goals.❞`,
    name: 'Ibong Okon',
    title: 'Scholarship Beneficiary',
  },
  {
    id: 4,
    image: image4,
    quote: `❝Thanks to the scholarship, I was able to focus on my studies without worrying about financial constraints. It's a gift that keeps on giving.❞`,
    name: 'Samuel Adedeji',
    title: 'Scholarship Beneficiary',
  },
  
  {
    id: 5,
    image: image5,
    quote: `❝It has been a great thing of joy, to be able to contribute to the success story of children. I am indeed grateful.❞`,
    name: 'Jonathan Morris',
    title: 'Donor',
  },
  // Add more testimonies as needed
];

const Testimonials = () => {
  const [currentTestimony, setCurrentTestimony] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimony((prev) => (prev === testimonies.length - 1 ? 0 : prev + 1));
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const handleSwipe = useSwipeable({
    onSwipedLeft: () => nextTestimony(),
    onSwipedRight: () => prevTestimony(),
  });

  const nextTestimony = () => {
    setCurrentTestimony((prev) => (prev === testimonies.length - 1 ? 0 : prev + 1));
  };

  const prevTestimony = () => {
    setCurrentTestimony((prev) => (prev === 0 ? testimonies.length - 1 : prev - 1));
  };

  return (
    <div name='testimonials' className="w-full min-h-[60vh]  bg-blue-50 pt-8" {...handleSwipe}>
      <div className="w-full max-w-xl mx-auto mt-3 px-2">
        <img
          className="w-[150px] h-[150px] rounded-full mx-auto"
          src={testimonies[currentTestimony].image}
          alt={testimonies[currentTestimony].name}
        />
        <blockquote className="text-center text-xl text-gray-800 mt-6">
          <footer className="block text-gray-600">{testimonies[currentTestimony].name}</footer>
          <footer className="text-sm block mb-20 text-gray-600">{testimonies[currentTestimony].title}</footer>
          <footer className="text-2xl word-spacing-1 block text-gray-600">{testimonies[currentTestimony].quote} </footer>
        </blockquote>
      </div>
      <div className="flex justify-center mt-24 pb-8">
        {testimonies.map((_, index) => (
          <FaCircle
            key={index}
            className={`text-xs mx-1 cursor-pointer ${
              currentTestimony === index ? 'text-[#15381b]' : 'text-gray-400'
            }`}
            onClick={() => setCurrentTestimony(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default Testimonials;
